module.exports = __webpack_public_path__ + "img/items_required.463519c1.jpg";